// View-model mapping for the history "Mesas" tab (closed table sessions).
// Pure so the chip/label mapping is unit-testable like the order formatters.
import type {
  IClosedTableSession,
  TSessionInvoiceState,
} from '@/api/services/table-sessions.service';

/** Card-ready session row (dates as epoch ms, like IOrderListItem). */
export interface ISessionListItem {
  id: string;
  tableName: string;
  closedAt: number;
  ordersCount: number;
  total: number;
  invoiceState: TSessionInvoiceState;
}

export function sessionToListItem(row: IClosedTableSession): ISessionListItem {
  return {
    id: row.id,
    tableName: row.tableName,
    closedAt: new Date(row.closedAt).getTime(),
    ordersCount: row.ordersCount,
    total: row.total,
    invoiceState: row.invoiceState,
  };
}

export interface ISessionInvoiceStateInfo {
  i18nKey: string;
  /** PosUiBadge color role. */
  color: 'success' | 'warning' | 'neutral' | 'info';
}

const INVOICE_STATE_INFO: Record<
  TSessionInvoiceState,
  ISessionInvoiceStateInfo
> = {
  invoiced: { i18nKey: 'posV2.sessionStateInvoiced', color: 'success' },
  partial: { i18nKey: 'posV2.sessionStatePartial', color: 'warning' },
  pending: { i18nKey: 'posV2.sessionStatePending', color: 'neutral' },
  // Sky/info: informational role (emerald would read as "invoiced").
  comped: { i18nKey: 'posV2.sessionStateComped', color: 'info' },
};

export function getSessionInvoiceStateInfo(
  state: TSessionInvoiceState
): ISessionInvoiceStateInfo {
  return INVOICE_STATE_INFO[state];
}
